module.exports = "<!-- * USER * -->\n<div class=\"row\">\n    <div class=\"container\">\n        <router-outlet></router-outlet>\n    </div>\n</div>\n"